export default "__VITE_ASSET__f06LqHnM__"